import { Box, Typography } from '@mui/material'
import { useAtomValue } from 'jotai'
import { selectedCraftAtom, selectedCraftingInnerTabAtom, selectedTierAtom } from '@/atoms'
import { useRecipeList } from '@/hooks/useRecipeList'
import { CRAFT_TYPE_LABEL, SKILL_TIERS } from '@/types/constants'
import { RecipeCard } from '@/components/ui/RecipeCard'

export function RecipeListPanel() {
  const craft = useAtomValue(selectedCraftAtom)
  const innerTab = useAtomValue(selectedCraftingInnerTabAtom)
  const tier = useAtomValue(selectedTierAtom)
  const recipes = useRecipeList()

  const tierLabel = tier !== null ? SKILL_TIERS[tier]?.label : null
  const modeLabel = innerTab === 'desynthesis' ? '分解' : '合成'

  return (
    <Box sx={{ gridArea: 'main', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
      {/* Panel header */}
      <Box sx={{ px: 1.5, py: 0.75, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="subtitle2" color="text.secondary">
          {CRAFT_TYPE_LABEL[craft]} / {modeLabel}
          {tierLabel ? ` — ${tierLabel}` : ''}
          <Typography component="span" variant="caption" sx={{ ml: 1 }}>
            {recipes.length} 件
          </Typography>
        </Typography>
      </Box>

      {/* Recipe list */}
      {recipes.length === 0 ? (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography color="text.disabled">レシピなし</Typography>
        </Box>
      ) : (
        <Box sx={{ flex: 1 }}>
          {recipes.map((recipe) => (
            <RecipeCard key={recipe.id} recipe={recipe} />
          ))}
        </Box>
      )}
    </Box>
  )
}
